import React from "react";
import { ShieldIcon } from "../../../../assets/images/svg/IconCollection";
import { ColorConstants } from "src/assets/custom/colors";
interface IAuthMethodHeaderProps {
    title: string;
}

const AuthMethodHeader: React.FC<IAuthMethodHeaderProps> = props => {
    return (
        <header className="AuthMethodHeader-wrapper app-header">
            <ShieldIcon width={26} height={26} color={ColorConstants.brand_primary_blue_1}/>
            <h2 className="compose-header-title">{props.title}</h2>
        </header>
    );
};

export default AuthMethodHeader;
